import React, { FC, ReactNode } from 'react'
import Container from './ButtonCard.style'

interface Props {
    disabled?: boolean
    children: ReactNode
    onClick: () => void
}

const ButtonCard: FC<Props> = ({ disabled, children, onClick }) => {
    return (
        <Container disabled={disabled} onClick={onClick}>
            {children}
        </Container>
    )
}

export default ButtonCard
